import React, { useState, useEffect } from "react";
import Layout from "../layout";
import Faq from "../home/faq";
import JoinUs from "../home/joinus";
import FollowUs from "../home/followus";
import { X, ChevronLeft, ChevronRight, Camera } from "lucide-react";

// Sample gallery data - replace with your actual data
const eventsData = [
  {
    id: "arjun-cup",
    title: "ARJUN CUP TAEKWONDO CHAMPIONSHIP",
    coverImage:
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/01.png",
    description:
      "Annual Taekwondo championship featuring talented athletes from across the region",
    images: [
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/01.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/02.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/03.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/04.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/05.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/06.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/07.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/08.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/09.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/10.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/11.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/12.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/13.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/14.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/15.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/17.png",

      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/19.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/20.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/21.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/22.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/23.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/24.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/25.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/26.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/27.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/28.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/29.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/30.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/31.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/32.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/33.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/34.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/35.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/36.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/37.png",
      "./assets/WEBSITE IMAGES/ARJUN CUP TAEKWONDO CHAMPIONSHIP/38.png",
    ],
  },
  {
    id: "BIKANER SPORTS LEAGUE",
    title: "BIKANER SPORTS LEAGUE 2023",
    coverImage: "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2023/06.png",
    description:
      "BIKANER SPORTS League featuring talented athletes from across the region",
    images: [
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2023/01.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2023/02.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2023/03.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2023/04.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2023/05.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2023/07.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2023/08.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2023/09.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2023/10.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2023/11.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2023/12.png",
    ],
  },
  {
    id: "BIKANER SPORTS LEAGUE 2024",
    title: "BIKANER SPORTS LEAGUE 2024",
    coverImage: "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/91.png",
    description:
      "BIKANER SPORTS LEAGUE 2024 featuring talented athletes from across the region",
    images: [
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/1.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/2.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/3.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/4.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/5.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/6.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/7.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/8.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/9.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/10.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/11.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/12.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/13.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/14.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/15.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/16.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/17.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/18.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/19.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/20.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/21.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/22.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/23.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/24.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/25.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/26.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/27.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/28.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/29.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/30.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/31.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/32.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/33.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/34.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/35.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/36.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/37.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/38.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/39.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/40.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/41.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/42.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/43.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/44.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/45.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/46.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/47.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/48.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/49.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/50.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/51.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/52.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/53.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/54.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/55.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/56.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/57.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/58.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/59.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/60.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/61.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/62.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/63.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/64.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/65.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/66.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/67.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/68.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/69.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/70.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/71.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/72.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/73.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/74.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/75.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/76.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/77.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/78.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/79.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/80.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/81.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/82.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/83.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/84.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/85.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/86.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/87.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/88.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/89.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/90.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/91.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/92.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/93.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/94.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/95.png",
      "./assets/WEBSITE IMAGES/BIKANER SPORTS LEAGUE 2024/96.png",
    ],
  },
  {
    id: "Media Coverage",
    title: "Media Coverage",
    coverImage: "./assets/WEBSITE IMAGES/media coverage/1.jpg",
    description: "Covered by media ",
    images: [
      "./assets/WEBSITE IMAGES/media coverage/1.jpg",
      "./assets/WEBSITE IMAGES/media coverage/2.jpg",
      "./assets/WEBSITE IMAGES/media coverage/3.jpg",
      "./assets/WEBSITE IMAGES/media coverage/4.jpg",
      "./assets/WEBSITE IMAGES/media coverage/5.jpg",
    ],
  },
  {
    id: "YOUTH ICON SKATING CHAMPIONSHIP",
    title: "Championship Skating icon ",
    coverImage: "./assets/WEBSITE IMAGES/YOUTH ICON SKATING CHAMPIONSHIP/1.png",
    description: "Championship Skating icon  ",
    images: [
      "./assets/WEBSITE IMAGES/YOUTH ICON SKATING CHAMPIONSHIP/1.png",
      "./assets/WEBSITE IMAGES/YOUTH ICON SKATING CHAMPIONSHIP/2.png",
      "./assets/WEBSITE IMAGES/YOUTH ICON SKATING CHAMPIONSHIP/3.png",
      "./assets/WEBSITE IMAGES/YOUTH ICON SKATING CHAMPIONSHIP/4.png",
      "./assets/WEBSITE IMAGES/YOUTH ICON SKATING CHAMPIONSHIP/6.png",
      "./assets/WEBSITE IMAGES/YOUTH ICON SKATING CHAMPIONSHIP/7.png",
      "./assets/WEBSITE IMAGES/YOUTH ICON SKATING CHAMPIONSHIP/8.png",
      "./assets/WEBSITE IMAGES/YOUTH ICON SKATING CHAMPIONSHIP/9.png",
      "./assets/WEBSITE IMAGES/YOUTH ICON SKATING CHAMPIONSHIP/10.png",
      "./assets/WEBSITE IMAGES/YOUTH ICON SKATING CHAMPIONSHIP/11.png",
      "./assets/WEBSITE IMAGES/YOUTH ICON SKATING CHAMPIONSHIP/12.png",
      "./assets/WEBSITE IMAGES/YOUTH ICON SKATING CHAMPIONSHIP/13.png",
    ],
  },
  {
    id: "Youth icon taekwondo championship 2024",
    title: "Youth icon taekwondo championship 2024 ",
    coverImage:
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/41.png",
    description: "Youth icon taekwondo championship 2024 ",
    images: [
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/1.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/2.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/3.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/4.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/5.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/6.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/7.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/8.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/9.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/10.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/11.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/12.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/13.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/14.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/15.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/16.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/17.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/18.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/19.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/20.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/21.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/22.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/23.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/24.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/25.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/26.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/27.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/28.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/29.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/30.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/31.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/32.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/33.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/34.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/35.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/36.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/37.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/38.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/39.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/40.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/41.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/42.png",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/43.png ",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/44.png ",
      "./assets/WEBSITE IMAGES/youth icon taekwondo championship 2024/45.png ",
    ],
  },
  {
    id: "Our Ground",
    title: "Our Ground",
    coverImage: "./assets/images/cricket/gallery17.jpeg",
    description: "Look At our ground",
    images: [
      "./assets/images/cricket/gallery14.jpeg",
      "./assets/images/cricket/gallery47.jpeg",
      "./assets/images/cricket/gallery48.jpeg",
      "./assets/images/cricket/gallery34.jpeg",
      "./assets/images/cricket/gallery35.jpeg",
      "./assets/images/cricket/gallery36.jpeg",
      "./assets/images/cricket/gallery37.jpeg",
      "./assets/images/cricket/gallery45.jpeg",
      "./assets/images/cricket/gallery46.jpeg",
      "./assets/images/cricket/gallery18.jpeg",
      "./assets/images/cricket/gallery33.jpeg",
      "./assets/images/cricket/gallery34.jpeg",
      "./assets/images/cricket/mrg01.jpeg",
      "./assets/images/cricket/mrg03.jpeg",
    ],
  },
  {
    id: "Cricket",
    title: "Cricket",
    coverImage: "./assets/images/cricket/gallery10.jpeg",
    description: "Cricket",
    images: [
      "./assets/images/cricket/gallery10.jpeg",
      "./assets/images/cricket/gallery11.jpeg",
      "./assets/images/cricket/gallery12.jpeg",
      "./assets/images/cricket/gallery13.jpeg",
      "./assets/images/cricket/gallery15.jpeg",
      "./assets/images/cricket/gallery16.jpeg",
      "./assets/images/cricket/gallery49.jpeg",
      "./assets/images/cricket/mrg06.jpeg",
      "./assets/images/cricket/mrg04.jpeg",
      "./assets/images/cricket/mrg05.jpeg",
      "./assets/images/cricket/mrg15.jpeg",
      "./assets/images/cricket/mrg14.jpeg",
      "./assets/images/cricket/mrg12.jpeg",
    ],
  },
  {
    id: "Skating",
    title: "Jaipur Open Skating Chempionship 2023",
    coverImage: "./assets/images/cricket/gallery6.jpeg",
    description: "Jaipur Open Skating Chempionship 2023",
    images: [
      "./assets/images/cricket/gallery6.jpeg",
      "./assets/images/cricket/gallery2.jpeg",
      "./assets/images/cricket/gallery3.jpeg",
      "./assets/images/cricket/gallery1.jpeg",
      "./assets/images/cricket/gallery5.jpeg",
      "./assets/images/cricket/gallery8.jpeg",
      "./assets/images/cricket/gallery26.jpeg",
      "./assets/images/cricket/gallery27.jpeg",
      "./assets/images/cricket/gallery28.jpeg",
      "./assets/images/cricket/gallery29.jpeg",
      "./assets/images/cricket/gallery30.jpeg",
      "./assets/images/cricket/gallery31.jpeg",
      "./assets/images/cricket/gallery38.jpeg",
      "./assets/images/cricket/gallery39.jpeg",
      "./assets/images/cricket/gallery52.jpeg",
    ],
  },
  {
    id: "Chess",
    title: "Jaipur Open Chess Chempionship 2023",
    coverImage: "./assets/images/cricket/gallery23.jpeg",
    description: "Jaipur Open Chess Chempionship 2023",
    images: [
      "./assets/images/cricket/gallery44.jpeg",
      "./assets/images/cricket/gallery24.jpeg",
      "./assets/images/cricket/gallery23.jpeg",
      "./assets/images/cricket/gallery20.jpeg",
      "./assets/images/cricket/gallery25.jpeg",
      "./assets/images/cricket/gallery22.jpeg",
    ],
  },
  {
    id: "Swimming Pool",
    title: "Swimming Pool",
    coverImage: "./assets/images/cricket/mrg18.jpeg",
    description: "Swimming Pool",
    images: [
      "./assets/images/cricket/mrg16.jpeg",
      "./assets/images/cricket/mrg18.jpeg",
    ],
  },
];

const Lightbox = ({
  images,
  currentIndex,
  onClose,
  onNext,
  onPrev,
  eventTitle,
}) => {
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onNext();
      if (e.key === "ArrowLeft") onPrev();
    };

    document.addEventListener("keydown", handleKeyPress);
    return () => document.removeEventListener("keydown", handleKeyPress);
  }, [onClose, onNext, onPrev]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-95 z-50 flex flex-col items-center">
      {/* Header */}
      <div className="w-full flex justify-between items-center p-4 text-white">
        <h3 className="text-xl font-semibold">{eventTitle}</h3>
        <button
          onClick={onClose}
          className="hover:text-gray-300 transition-colors"
        >
          <X className="h-8 w-8" />
        </button>
      </div>

      {/* Main Image */}
      <div className="flex-1 w-full flex items-center justify-center relative">
        <button
          onClick={onPrev}
          className="absolute left-4 text-white hover:text-gray-300 transition-colors"
        >
          <ChevronLeft className="h-12 w-12" />
        </button>

        <img
          src={images[currentIndex]}
          alt={`${eventTitle} image ${currentIndex + 1}`}
          className="max-h-[75vh] max-w-[90vw] object-contain"
        />

        <button
          onClick={onNext}
          className="absolute right-4 text-white hover:text-gray-300 transition-colors"
        >
          <ChevronRight className="h-12 w-12" />
        </button>
      </div>

      {/* Thumbnails */}
      <div className="w-full overflow-x-auto p-4">
        <div className="flex space-x-2 justify-center">
          {images.map((img, idx) => (
            <button
              key={idx}
              onClick={() => onNext(idx)}
              className={`flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden ${
                idx === currentIndex ? "ring-2 ring-blue-500" : ""
              }`}
            >
              <img
                src={img}
                alt={`Thumbnail ${idx + 1}`}
                className="w-full h-full object-cover"
              />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

const EventCard = ({ event, onOpenGallery }) => (
  <div className="bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 hover:shadow-xl">
    <div className="relative aspect-[16/9] overflow-hidden">
      <img
        src={event.coverImage}
        alt={event.title}
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black bg-opacity-40 opacity-0 hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
        <button
          onClick={() => onOpenGallery(event)}
          className="bg-white bg-opacity-90 text-gray-900 px-6 py-3 rounded-full font-medium flex items-center space-x-2 transform hover:scale-105 transition-transform"
        >
          <Camera className="h-5 w-5" />
          <span>View Gallery</span>
        </button>
      </div>
    </div>
    <div className="p-6">
      <h3 className="text-xl font-bold text-gray-900 mb-2">{event.title}</h3>
      <p className="text-gray-600">{event.description}</p>
      <div className="mt-4 flex items-center text-gray-500">
        <Camera className="h-5 w-5 mr-2" />
        <span>{event.images.length} photos</span>
      </div>
    </div>
  </div>
);

const Gallery = () => {
  const [lightbox, setLightbox] = useState({
    isOpen: false,
    images: [],
    currentIndex: 0,
    eventTitle: "",
  });

  const openGallery = (event) => {
    setLightbox({
      isOpen: true,
      images: event.images,
      currentIndex: 0,
      eventTitle: event.title,
    });
    document.body.style.overflow = "hidden";
  };

  const closeLightbox = () => {
    setLightbox((prev) => ({ ...prev, isOpen: false }));
    document.body.style.overflow = "unset";
  };

  const nextImage = (index) => {
    setLightbox((prev) => ({
      ...prev,
      currentIndex:
        typeof index === "number"
          ? index
          : (prev.currentIndex + 1) % prev.images.length,
    }));
  };

  const prevImage = () => {
    setLightbox((prev) => ({
      ...prev,
      currentIndex:
        (prev.currentIndex - 1 + prev.images.length) % prev.images.length,
    }));
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="section pt-24 pb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Our Events Gallery
            </h1>
            <p className="text-lg text-gray-600">
              Explore our sporting events and championships through memorable
              moments
            </p>
          </div>
        </div>
      </div>

      {/* Events Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {eventsData.map((event) => (
            <EventCard
              key={event.id}
              event={event}
              onOpenGallery={openGallery}
            />
          ))}
        </div>
      </div>

      {/* Instagram Feed */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        <h2 className="text-2xl font-bold text-gray-900 mb-8">
          Follow Us on Instagram
        </h2>
        <div className="elfsight-app-eb894a1c-03cc-49f4-bc9c-108ba58f685e"></div>
      </div>

      {lightbox.isOpen && (
        <Lightbox
          images={lightbox.images}
          currentIndex={lightbox.currentIndex}
          onClose={closeLightbox}
          onNext={nextImage}
          onPrev={prevImage}
          eventTitle={lightbox.eventTitle}
        />
      )}

      <Faq />
      <JoinUs />
      <FollowUs />
    </div>
  );
};

export default Gallery;
